import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { selectedDataElementList } from "../../actions/admin";
import { capitalizeFirstLetter, formatBackendDateToCST } from "../../utils/comman";
import { useParams } from "react-router-dom";

const ViewDataElements = () => {
  const location = useParams();
  const dispatch = useDispatch<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [element, setElement] = useState<any>();

  const getElementData = () => {
    setLoading(true);
    dispatch(
      selectedDataElementList(location?.id, (resp: any) => {
        setLoading(false);
        if (resp?.status === 200 || resp?.status === 201) {
          setElement(resp?.data || []);
        }
      })
    );
  };

  useEffect(() => {
    getElementData();
  }, []);



  return (
    <div>
      {/* <Header /> */}
      <div className="flex gap-[20px] mt-[20px] flex-wrap">
        <div className="flex brand-details-wrapper p-[10px] gap-[60px] items-center 2xl:gap-[100px] rounded-[10px] bg-primary size-full  flex-col md:flex-row justify-center sm:justify-start">

          <div className="text-center sm:text-start  w-full sm:w-[calc(50%-30px)] md:w-1/3">
            <h3 className="mb-[10px]"></h3>

            <p className="info-col"></p>

            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col min-w-[65px]">
                Data&nbsp;Element&nbsp;Name :
              </p>
              <p>
                {element?.DataElements_Name ? element?.DataElements_Name : "-"}
              </p>
            </div>

            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col">Data&nbsp;Element&nbsp;Description : </p>
              <p>
                {element?.DataElements_Description
                  ? element?.DataElements_Description
                  : "-"}
              </p>
            </div>
            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col">Data&nbsp;Element&nbsp;XDescription :  </p>
              <p>
                {element?.DataElements_XDescription
                  ? element?.DataElements_XDescription
                  : "-"}
              </p>
            </div>
            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col">
                Data&nbsp;Element&nbsp;Data&nbsp;Type :
              </p>
              <p>
                {element?.DataElements_DataType
                  ? capitalizeFirstLetter(element?.DataElements_DataType)
                  : "-"}
              </p>
            </div>

            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col">
                Data&nbsp;Element&nbsp;Interval&nbsp; :
              </p>
              <p>
                {element?.interval?.Interval_Name
                  ? element?.interval?.Interval_Name
                  : "-"}
              </p>
            </div>

            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col">
                Data&nbsp;Element&nbsp;Is&nbsp;Budgeted :
              </p>
              <p>
                {
                  element?.DataElements_IsBudgeted 
                    ? "Yes"
                    : "No"
                  }
              </p>
            </div>
          </div>

          <div className="text-center sm:text-start w-full sm:w-[calc(50%-30px)] md:w-1/3">
            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col min-w-[65px]">
                Data&nbsp;Element&nbsp;Is&nbsp;Calculated :
              </p>
              <p>
                {
                   element?.DataElements_IsCalculated 
                    ? "Yes"
                    : "No"
                  }
              </p>
            </div>

            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col">
                Data&nbsp;Element&nbsp;Is&nbsp;RollUp :
              </p>
              <p>
                { element?.DataElements_IsRollUp
                    ? "Yes"
                    : "No"
                  }
              </p>
            </div>
            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col">
                Data&nbsp;Element&nbsp;Last&nbsp;Updated :
              </p>
              <p>
                {element?.updatedAt
                  ? formatBackendDateToCST(element?.updatedAt)
                  : "-"}
              </p>
            </div>

            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col">
                Data&nbsp;Element&nbsp;Last&nbsp;Updated&nbsp;By : 
              </p>
              <p>
                {element?.DataElements_LastUpdatedBy
                  ? element?.DataElements_LastUpdatedBy
                  : "-"}
              </p>
            </div>

            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col">
                Data&nbsp;Element&nbsp;Starting&nbsp;Due&nbsp;Date :
              </p>
              <p>
                {element?.DataElements_StartingDueDate
                  ? element?.DataElements_StartingDueDate
                  : "-"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDataElements;
